import restRequest from './restClient';

// A plain function, not a useAsyncCall hook: the provider must resolve the locale before it renders
// anything, so it cannot drive this from a hook's imperative execute.
//
// The signal is a second argument rather than part of the params object so that object stays a 1:1
// map of the query string.
export default function fetchGlobalization(params, signal) {
  const { country, market, language } = params || {};
  return restRequest({
    path: '/air-api/v1/globalization',
    // Distinct lookup modes upstream: a market slug passed as country resolves the wrong country.
    params: { country, market, language },
    signal,
  });
}
